import React from 'react';
import TimeFrameDisplay from './time-frame-display/TimeFrameDisplay';
import { BaseTimePeriod } from '@services/FiltersTypes';
import classnames from 'classnames';

import * as styles from '@components/time-frame-picker/TimeFramePicker.module.scss';

export type PeriodDisplayControlProps = {
  isTimeFramePickerDisabled: boolean;
  isOpen: boolean;
  earliestPeriod: BaseTimePeriod;
  latestPeriod: BaseTimePeriod;
  onTogglePicker: () => void;
  isDisplayNoComparisonLabel: boolean;
};

const PeriodDisplayControl: React.FC<PeriodDisplayControlProps> = ({
  children,
  isTimeFramePickerDisabled,
  isOpen,
  earliestPeriod,
  latestPeriod,
  onTogglePicker,
  isDisplayNoComparisonLabel,
}) => {
  const isPeriodSelected = !!(earliestPeriod.value && latestPeriod.value);
  const isDisableTFP = isTimeFramePickerDisabled || !isPeriodSelected; //NOSONAR typescript:S6606
  return (
    <div
      className={classnames(
        styles.TimeFramePicker,
        {
          [styles['TimeFramePicker--disabled']]: isDisableTFP,
        },
        'z-index-dropdown',
      )}
      data-testid={`PeriodDisplayControl${isDisableTFP ? '-disabled' : ''}`}
    >
      <b className="text-md font-bold w-auto text-heading truncate pt-1 pb-0.5 inline-block">Time Frame</b>
      <button
        className={classnames(styles.TimeFramePicker__Wrapper, {
          [styles['TimeFramePicker__Wrapper--focused']]: isOpen,
        })}
        id="Time_Frame"
        onClick={isDisableTFP ? () => {} : onTogglePicker}
        data-testid={`PeriodDisplayControl__Wrapper${isOpen ? '-focused' : ''}`}
      >
        <TimeFrameDisplay
          isPeriodSelected={isPeriodSelected}
          earliestPeriod={earliestPeriod}
          latestPeriod={latestPeriod}
          isDisplayNoComparisonLabel={isDisplayNoComparisonLabel}
        />
      </button>
      <div>{children}</div>
    </div>
  );
};

export default PeriodDisplayControl;
